const maxWidth = '700px';

const styles = theme => ({
  root: {
    maxWidth,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F2F2F2',
    fontFamily: 'Roboto',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    height: theme.spacing(7),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      position: 'initial',
    },
  },
  title: {
    display: 'flex',
    width: 'auto',
    fontSize: '20px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gridTemplateRows: 'auto 2fr auto',
    // overflowY: 'auto',
    marginTop: theme.spacing(7),
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  gridNoHeight: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gridTemplateRows: 'auto 2fr auto',
    // overflowY: 'auto',
    minHeight: '84vh',
    marginTop: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  mapOrNavigationBox: {
    gridColumn: '1 / 3',
    gridRow: '1 / 2',

    [theme.breakpoints.up('sm')]: {
      gridColumn: '1 / 2',
      gridRow: '1 / 3',
      marginRight: theme.spacing(),
    },
  },
  main: {
    gridColumn: '1 / 3',
    gridRow: '2 / 3',

    [theme.breakpoints.up('sm')]: {
      gridColumn: '2 / 3',
      // gridRow: '1 / 3',
    },
  },
  footer: {
    gridColumn: '1 / 3',
    gridRow: '3 / 4',
    display: 'flex',
    justifyContent: 'center',
    padding: '12px',
    backgroundColor: '#ffffff',

    [theme.breakpoints.up('sm')]: {
      gridColumn: '2 / 3',
      gridRow: '3 / 4',
    },
  },
  mainButton: {
    fontSize: '20px',
    lineHeight: '26px',
  },
  paper: {
    [theme.breakpoints.up('sm')]: {
      maxWidth,
    },
  },
  expiredSessionBox: {
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(7),
    backgroundColor: '#ffffff',
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  noBookableStaffBox: {
    justifyContent: 'center',
    marginTop: theme.spacing(7),
    backgroundColor: '#ffffff',
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  avatarPosition: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      width: '67%',
      display: 'flex',
      justifyContent: 'start'
    },
  },
  contentPosition: {
    height: '100%',
    div: {
      marginTop: 0,
    }
  },
});

export default styles;
